<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  name: 'users-chart',
  props: ['data'],
  methods: {
    render() {
      const { preregistered, active, ex_client } = this.data;
      const options = {
        legend: {
          display: false,
        },
      };

      this.renderChart(
        {
          labels: ['Pré-Cadastrados', 'Ativos', 'Ex-Usuário'],
          datasets: [
            {
              data: [preregistered, active, ex_client],
              backgroundColor: ['#130d85', '#48d376','#d04040',],
              hoverBackgroundColor: ['#130c45','#48d746','#d04050'],
            },
          ],
        },
        options
      );
    },
  },
  watch: {
    data() {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
};
</script>
